export const RoleMasterInitialInput = {
  roleName: '',
  module: '',
}

export const PartnerMasterInitialInput = {
  companyName: '',
  partnerName: '',
  contactNo: '',
  panNo: '',
  aadharNo: '',
  gstNo: '',
  gstApplicable: '',
  gstReason: '',
  status: '',
  address: '',
  email: '',
  createdBy: '',
  panDoc: null,
  aadharDoc: null,
  gstDoc: null,
}

export const EmploymentTypeInitialInput = {
  name: '',
  duration: '',
  description: '',
}
